import { createContext } from "react"

export const contextValues = createContext<ContextValues>({
  usdValueForWinLose: "",
  usdValueForContract: "",
  clpValue: "",
})
